import { render, staticRenderFns } from "./workTemplate.vue?vue&type=template&id=1fd078d3&scoped=true&"
import script from "./workTemplate.vue?vue&type=script&lang=ts&"
export * from "./workTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./workTemplate.vue?vue&type=style&index=0&id=1fd078d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd078d3",
  null
  
)

export default component.exports